import { Tab } from '@headlessui/react'
import React, { useEffect } from 'react'
import { FiChevronRight } from 'react-icons/fi'
import { MdPassword } from 'react-icons/md'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'


export const AccountPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  useEffect(() => {
    if (location.pathname === '/app/account') {
      navigate('/app/account/basic-info')
    }
  }, [location])

  return (
    <div className='font-dashboard pt-2 pb-12 md:px-4 min-h-screen'>
      <div className='container-lg relative '>
        <div className='w-full md:grid md:grid-cols-12 md:grid-rows-1 md:gap-4'>
          <div className='md:col-span-3 flex flex-col md:block mt-6'>
            <h3 className='text-white/30 text-sm font-light pl-4 md:pl-0 mb-4 uppercase'>
              Account setup
            </h3>
            <div className='w-full px-4 md:px-0 py-2 flex flex-row md:flex-col gap-3 focus:outline-none'>
              <NavLink to='/app/account/basic-info' className=''>
                {({ isActive }) => (
                  <>
                    <div className='flex items-center gap-2'>
                      <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className={`box-content p-2 rounded-full border hidden md:block ${isActive ? 'border-primary' : 'border-white/50'
                          } `}
                      >
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M14 4.375C10.6173 4.375 7.875 7.11726 7.875 10.5C7.875 13.8827 10.6173 16.625 14 16.625C17.3827 16.625 20.125 13.8827 20.125 10.5C20.125 7.11726 17.3827 4.375 14 4.375ZM6.125 10.5C6.125 6.15076 9.65076 2.625 14 2.625C18.3492 2.625 21.875 6.15076 21.875 10.5C21.875 14.8492 18.3492 18.375 14 18.375C9.65076 18.375 6.125 14.8492 6.125 10.5Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M14.0001 18.3711C12.0032 18.3711 10.0415 18.8968 8.31219 19.8953C6.58287 20.8939 5.14688 22.33 4.14858 24.0595C3.907 24.478 3.37187 24.6215 2.95334 24.3799C2.53481 24.1383 2.39137 23.6032 2.63296 23.1846C3.78484 21.1891 5.44175 19.532 7.43712 18.3798C9.4325 17.2277 11.696 16.6211 14.0001 16.6211C16.3043 16.6211 18.5678 17.2277 20.5632 18.3798C22.5585 19.532 24.2155 21.1891 25.3673 23.1846C25.6089 23.6032 25.4655 24.1383 25.047 24.3799C24.6284 24.6215 24.0933 24.478 23.8517 24.0595C22.8534 22.33 21.4174 20.8939 19.6881 19.8953C17.9588 18.8968 15.9971 18.3711 14.0001 18.3711Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                      </svg>

                      <p
                        className={`${isActive ? 'text-primary' : 'text-white/50'
                          }  text-sm`}
                      >
                        Basic Info
                      </p>
                      <FiChevronRight
                        className={`text-lg hidden md:block ${isActive ? 'text-primary' : 'text-white/60'
                          }  ml-auto mr-2`}
                      />
                    </div>

                    <hr
                      className={`${isActive ? 'border-primary' : 'border-white/40'
                        }  mt-3`}
                    />
                  </>
                )}
              </NavLink>
              <NavLink to='/app/account/change-password' className=''>
                {({ isActive }) => (
                  <>
                    <div className='flex items-center gap-2'>
                      <MdPassword
                        className={`box-content p-2.5 rounded-full text-2xl border hidden md:block ${isActive
                          ? 'border-primary text-primary'
                          : 'border-white/50 text-white/50'
                          }`}
                      />

                      <p
                        className={`${isActive ? 'text-primary' : 'text-white/50'
                          }  text-sm`}
                      >
                        Change Password
                      </p>
                      <FiChevronRight
                        className={`text-lg hidden md:block ${isActive ? 'text-primary' : 'text-white/60'
                          }  ml-auto mr-2`}
                      />
                    </div>

                    <hr
                      className={`${isActive ? 'border-primary' : 'border-white/40'
                        }  mt-3`}
                    />
                  </>
                )}
              </NavLink>

              <NavLink to='/app/account/two-factor-security'>
                {({ isActive }) => (
                  <div className='w-full'>
                    <div className='flex items-center gap-2'>
                      <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className={`box-content p-2 rounded-full border hidden md:block ${isActive ? 'border-primary' : 'border-white/50'
                          } `}
                      >
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M3.5 10.5C3.5 9.5335 4.2835 8.75 5.25 8.75L22.75 8.75C23.7165 8.75 24.5 9.5335 24.5 10.5V22.75C24.5 23.7165 23.7165 24.5 22.75 24.5H5.25C4.2835 24.5 3.5 23.7165 3.5 22.75L3.5 10.5ZM22.75 10.5L5.25 10.5L5.25 22.75H22.75V10.5Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M14 2.625C13.1878 2.625 12.4088 2.94766 11.8345 3.52199C11.2602 4.09632 10.9375 4.87527 10.9375 5.6875L10.9375 9.625C10.9375 10.1082 10.5457 10.5 10.0625 10.5C9.57925 10.5 9.1875 10.1082 9.1875 9.625L9.1875 5.6875C9.1875 4.41115 9.69453 3.18707 10.597 2.28455C11.4996 1.38203 12.7236 0.875 14 0.875C15.2764 0.875 16.5004 1.38203 17.403 2.28455C18.3055 3.18707 18.8125 4.41115 18.8125 5.6875V9.625C18.8125 10.1082 18.4208 10.5 17.9375 10.5C17.4543 10.5 17.0625 10.1082 17.0625 9.625V5.6875C17.0625 4.87527 16.7398 4.09632 16.1655 3.52199C15.5912 2.94766 14.8122 2.625 14 2.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                      </svg>

                      <p
                        className={`${isActive ? 'text-primary' : 'text-white/50'
                          }  text-sm`}
                      >
                        2FA Security
                      </p>
                      <FiChevronRight
                        className={`text-lg hidden md:block ${isActive ? 'text-primary' : 'text-white/60'
                          }  ml-auto mr-2`}
                      />
                    </div>
                    <hr
                      className={`${isActive ? 'border-primary' : 'border-white/40'
                        }  mt-3`}
                    />
                  </div>
                )}
              </NavLink>

              <NavLink to='/app/account/payment-details'>
                {({ isActive }) => (
                  <div className='w-full'>
                    <div className='flex items-center gap-2'>
                      <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className={`box-content p-2 rounded-full border hidden md:block ${isActive ? 'border-primary' : 'border-white/50'
                          } `}
                      >
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M13.5415 2.7548C13.8227 2.58173 14.1774 2.58173 14.4587 2.7548L25.8337 9.7548C26.1671 9.95997 26.3236 10.3616 26.217 10.7383C26.1104 11.115 25.7665 11.375 25.3751 11.375L2.62507 11.375C2.2336 11.375 1.88976 11.115 1.78315 10.7383C1.67653 10.3616 1.83309 9.95997 2.16649 9.7548L13.5415 2.7548ZM5.71649 9.625L22.2837 9.625L14.0001 4.52741L5.71649 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M6.125 9.625C6.60825 9.625 7 10.0168 7 10.5L7 19.25C7 19.7333 6.60825 20.125 6.125 20.125C5.64175 20.125 5.25 19.7333 5.25 19.25L5.25 10.5C5.25 10.0168 5.64175 9.625 6.125 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M11.375 9.625C11.8582 9.625 12.25 10.0168 12.25 10.5L12.25 19.25C12.25 19.7333 11.8582 20.125 11.375 20.125C10.8918 20.125 10.5 19.7333 10.5 19.25L10.5 10.5C10.5 10.0168 10.8918 9.625 11.375 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M16.625 9.625C17.1082 9.625 17.5 10.0168 17.5 10.5V19.25C17.5 19.7333 17.1082 20.125 16.625 20.125C16.1418 20.125 15.75 19.7333 15.75 19.25L15.75 10.5C15.75 10.0168 16.1418 9.625 16.625 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M21.875 9.625C22.3582 9.625 22.75 10.0168 22.75 10.5V19.25C22.75 19.7333 22.3582 20.125 21.875 20.125C21.3918 20.125 21 19.7333 21 19.25V10.5C21 10.0168 21.3918 9.625 21.875 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M2.625 19.2461C2.625 18.7628 3.01675 18.3711 3.5 18.3711L24.5 18.3711C24.9833 18.3711 25.375 18.7628 25.375 19.2461C25.375 19.7293 24.9833 20.1211 24.5 20.1211L3.5 20.1211C3.01675 20.1211 2.625 19.7293 2.625 19.2461Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M0.875 22.7461C0.875 22.2628 1.26675 21.8711 1.75 21.8711L26.25 21.8711C26.7332 21.8711 27.125 22.2628 27.125 22.7461C27.125 23.2293 26.7332 23.6211 26.25 23.6211L1.75 23.6211C1.26675 23.6211 0.875 23.2293 0.875 22.7461Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                      </svg>

                      <p
                        className={`${isActive ? 'text-primary' : 'text-white/50'
                          }  text-sm`}
                      >
                        Payment Details
                      </p>
                      <FiChevronRight
                        className={`text-lg hidden md:block ${isActive ? 'text-primary' : 'text-white/60'
                          }  ml-auto mr-2`}
                      />
                    </div>
                    <hr
                      className={`${isActive ? 'border-primary' : 'border-white/40'
                        }  mt-3`}
                    />
                  </div>
                )}
              </NavLink>
              <NavLink to='/app/account/kyc'>
                {({ isActive }) => (
                  <div className='w-full'>
                    <div className='flex items-center gap-2'>



                      <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className={`box-content p-2 rounded-full border hidden md:block ${isActive ? 'border-primary' : 'border-white/50'
                          } `}
                      >
                        {/* <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M13.5415 2.7548C13.8227 2.58173 14.1774 2.58173 14.4587 2.7548L25.8337 9.7548C26.1671 9.95997 26.3236 10.3616 26.217 10.7383C26.1104 11.115 25.7665 11.375 25.3751 11.375L2.62507 11.375C2.2336 11.375 1.88976 11.115 1.78315 10.7383C1.67653 10.3616 1.83309 9.95997 2.16649 9.7548L13.5415 2.7548ZM5.71649 9.625L22.2837 9.625L14.0001 4.52741L5.71649 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M6.125 9.625C6.60825 9.625 7 10.0168 7 10.5L7 19.25C7 19.7333 6.60825 20.125 6.125 20.125C5.64175 20.125 5.25 19.7333 5.25 19.25L5.25 10.5C5.25 10.0168 5.64175 9.625 6.125 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M11.375 9.625C11.8582 9.625 12.25 10.0168 12.25 10.5L12.25 19.25C12.25 19.7333 11.8582 20.125 11.375 20.125C10.8918 20.125 10.5 19.7333 10.5 19.25L10.5 10.5C10.5 10.0168 10.8918 9.625 11.375 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M16.625 9.625C17.1082 9.625 17.5 10.0168 17.5 10.5V19.25C17.5 19.7333 17.1082 20.125 16.625 20.125C16.1418 20.125 15.75 19.7333 15.75 19.25L15.75 10.5C15.75 10.0168 16.1418 9.625 16.625 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M21.875 9.625C22.3582 9.625 22.75 10.0168 22.75 10.5V19.25C22.75 19.7333 22.3582 20.125 21.875 20.125C21.3918 20.125 21 19.7333 21 19.25V10.5C21 10.0168 21.3918 9.625 21.875 9.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M2.625 19.2461C2.625 18.7628 3.01675 18.3711 3.5 18.3711L24.5 18.3711C24.9833 18.3711 25.375 18.7628 25.375 19.2461C25.375 19.7293 24.9833 20.1211 24.5 20.1211L3.5 20.1211C3.01675 20.1211 2.625 19.7293 2.625 19.2461Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M0.875 22.7461C0.875 22.2628 1.26675 21.8711 1.75 21.8711L26.25 21.8711C26.7332 21.8711 27.125 22.2628 27.125 22.7461C27.125 23.2293 26.7332 23.6211 26.25 23.6211L1.75 23.6211C1.26675 23.6211 0.875 23.2293 0.875 22.7461Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        /> */}


                        <path d="M21.5833 4.79471L15.7616 2.61305C14.7933 2.25138 13.2066 2.25138 12.2383 2.61305L6.4166 4.79471C5.07494 5.29638 3.97827 6.88305 3.97827 8.30638V16.9747C3.97827 18.3514 4.88827 20.1597 5.9966 20.988L11.0133 24.733C12.6583 25.9697 15.3649 25.9697 17.0099 24.733L22.0266 20.988C23.1349 20.1597 24.0449 18.3514 24.0449 16.9747V8.30638C24.0216 6.88305 22.9249 5.29638 21.5833 4.79471ZM13.9183 8.20138C15.2949 8.20138 16.4149 9.32138 16.4149 10.698C16.4149 12.0514 15.3533 13.1364 14.0116 13.183H13.9883H13.9649C13.9416 13.183 13.9183 13.183 13.8949 13.183C12.4949 13.1364 11.4449 12.0514 11.4449 10.698C11.4333 9.32138 12.5533 8.20138 13.9183 8.20138ZM16.5549 19.0864C15.8433 19.553 14.9216 19.798 13.9999 19.798C13.0783 19.798 12.1449 19.5647 11.4449 19.0864C10.7799 18.643 10.4183 18.0364 10.4066 17.3714C10.4066 16.718 10.7799 16.088 11.4449 15.6447C12.8566 14.7114 15.1549 14.7114 16.5666 15.6447C17.2316 16.088 17.6049 16.6947 17.6049 17.3597C17.5933 18.013 17.2199 18.643 16.5549 19.0864Z" fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `} />


                      </svg>

                      <p
                        className={`${isActive ? 'text-primary' : 'text-white/50'
                          }  text-sm`}
                      >
                        KYC Verification
                      </p>
                      <FiChevronRight
                        className={`text-lg hidden md:block ${isActive ? 'text-primary' : 'text-white/60'
                          }  ml-auto mr-2`}
                      />
                    </div>
                    <hr
                      className={`${isActive ? 'border-primary' : 'border-white/40'
                        }  mt-3`}
                    />
                  </div>
                )}
              </NavLink>
              <NavLink to='/app/account/active-sessions'>
                {({ isActive }) => (
                  <div className='w-full'>
                    <div className='flex items-center gap-2'>
                      <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className={`box-content p-2 rounded-full border hidden md:block ${isActive ? 'border-primary' : 'border-white/50'
                          } `}
                      >
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M3.5 10.5C3.5 9.5335 4.2835 8.75 5.25 8.75L22.75 8.75C23.7165 8.75 24.5 9.5335 24.5 10.5V22.75C24.5 23.7165 23.7165 24.5 22.75 24.5H5.25C4.2835 24.5 3.5 23.7165 3.5 22.75L3.5 10.5ZM22.75 10.5L5.25 10.5L5.25 22.75H22.75V10.5Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M14 2.625C13.1878 2.625 12.4088 2.94766 11.8345 3.52199C11.2602 4.09632 10.9375 4.87527 10.9375 5.6875L10.9375 9.625C10.9375 10.1082 10.5457 10.5 10.0625 10.5C9.57925 10.5 9.1875 10.1082 9.1875 9.625L9.1875 5.6875C9.1875 4.41115 9.69453 3.18707 10.597 2.28455C11.4996 1.38203 12.7236 0.875 14 0.875C15.2764 0.875 16.5004 1.38203 17.403 2.28455C18.3055 3.18707 18.8125 4.41115 18.8125 5.6875V9.625C18.8125 10.1082 18.4208 10.5 17.9375 10.5C17.4543 10.5 17.0625 10.1082 17.0625 9.625V5.6875C17.0625 4.87527 16.7398 4.09632 16.1655 3.52199C15.5912 2.94766 14.8122 2.625 14 2.625Z'
                          fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `}
                        />
                      </svg>

                      <p
                        className={`${isActive ? 'text-primary' : 'text-white/50'
                          }  text-sm`}
                      >
                        Active Sessions
                      </p>
                      <FiChevronRight
                        className={`text-lg hidden md:block ${isActive ? 'text-primary' : 'text-white/60'
                          }  ml-auto mr-2`}
                      />
                    </div>
                    <hr
                      className={`${isActive ? 'border-primary' : 'border-white/40'
                        }  mt-3`}
                    />
                  </div>
                )}
              </NavLink>
              <NavLink to='/app/account/close'>
                {({ isActive }) => (
                  <div className='w-full'>
                    <div className='flex items-center gap-2'>
                      <svg width="28px" height="28px" viewBox="0 0 1024 1024"
                        version="1.1" xmlns="http://www.w3.org/2000/svg"
                        className={`box-content p-2 rounded-full border hidden md:block ${isActive ? 'border-primary' : 'border-white/50'
                          } `}
                      >
                        <path d="M960 160h-291.2a160 160 0 0 0-313.6 0H64a32 32 0 0 0 0 64h896a32 32 0 0 0 0-64zM512 96a96 96 0 0 1 90.24 64h-180.48A96 96 0 0 1 512 96zM844.16 290.56a32 32 0 0 0-34.88 6.72A32 32 0 0 0 800 320a32 32 0 1 0 64 0 33.6 33.6 0 0 0-9.28-22.72 32 32 0 0 0-10.56-6.72zM832 416a32 32 0 0 0-32 32v96a32 32 0 0 0 64 0v-96a32 32 0 0 0-32-32zM832 640a32 32 0 0 0-32 32v224a32 32 0 0 1-32 32H256a32 32 0 0 1-32-32V320a32 32 0 0 0-64 0v576a96 96 0 0 0 96 96h512a96 96 0 0 0 96-96v-224a32 32 0 0 0-32-32z" fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `} />
                        <path d="M384 768V352a32 32 0 0 0-64 0v416a32 32 0 0 0 64 0zM544 768V352a32 32 0 0 0-64 0v416a32 32 0 0 0 64 0zM704 768V352a32 32 0 0 0-64 0v416a32 32 0 0 0 64 0z" fill={`${isActive ? '#FFCC00' : '#ffffffc7'} `} />
                      </svg>

                      <p
                        className={`${isActive ? 'text-primary' : 'text-white/50'
                          }  text-sm`}
                      >
                        Close Account
                      </p>
                      <FiChevronRight
                        className={`text-lg hidden md:block ${isActive ? 'text-primary' : 'text-white/60'
                          }  ml-auto mr-2`}
                      />
                    </div>
                    <hr
                      className={`${isActive ? 'border-primary' : 'border-white/40'
                        }  mt-3`}
                    />
                  </div>
                )}
              </NavLink>
            </div>
          </div>
          <div className='md:col-span-9 mt-4'>
            <div className='md:bg-black md:min-h-screen focus:outline-none'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
